import axios from "axios";
import ConnUrls from '../Connections/ConnectURL';

// ערים (server: _routers/citiesRouter.js)

// הערים הפעילות: [{ _id, name, slug, order }]
const getCities = async () => (await axios.get(ConnUrls.ApiUrl + "cities")).data;

// זיהוי עיר לפי נ.צ: { city } או { city: null }
const locate = async (lat, lng) =>
    (await axios.get(ConnUrls.ApiUrl + "cities/locate", { params: { lat, lng }, timeout: 10000 })).data;

// מיקום הדפדפן. navigator.geolocation עובד רק ב-https או http://localhost.
// נכשל עם reason: 'unsupported' | 'denied' | 'unavailable' | 'timeout'
const getPosition = (timeoutMs = 10000) => new Promise((resolve, reject) => {
    if (!navigator.geolocation || (typeof window !== 'undefined' && window.isSecureContext === false)) {
        reject({ reason: 'unsupported' });
        return;
    }
    navigator.geolocation.getCurrentPosition(
        (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
        (err) => reject({ reason: err && err.code === 1 ? 'denied' : err && err.code === 3 ? 'timeout' : 'unavailable' }),
        { enableHighAccuracy: false, timeout: timeoutMs, maximumAge: 5 * 60 * 1000 }
    );
});

export default {
    getCities,
    locate,
    getPosition,
};
